import styled from 'styled-components';
import tw, { classnames, textColor } from 'tailwindcss-classnames'

export const Subtitle = styled.h4.attrs({
    className: classnames(textColor('text-gray-500'))
})`
    font-size: 1.2rem;
    font-weight: 300;
`